// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.documentacion-container {
    width: 100%;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
}

.documentacion-container > .card {
    width: 46%;
    border: 3px solid #f09502;
    background-color: #0e0f15; 
    color: white;
}

.documentacion-container > .card:hover {
    background-color: #07070a;
    cursor: grab;
}

.documentacion-container > .card h5 i {
    margin-right: 8px;
}

.documentacion-container > .card button i {
    margin-right: 8px;
}

@media (max-width: 500px) {
    .documentacion-container {
        width: 100%;
        margin: 0 0;
        padding-bottom: 250px !important;
        height: 100vh;
        overflow-y: scroll;
    }

    .documentacion-container > .card {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/documentation/documentation.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;QACX,WAAW;QACX,gCAAgC;QAChC,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.documentacion-container {\n    width: 100%;\n    margin: 0;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.documentacion-container > .card {\n    width: 46%;\n    border: 3px solid #f09502;\n    background-color: #0e0f15; \n    color: white;\n}\n\n.documentacion-container > .card:hover {\n    background-color: #07070a;\n    cursor: grab;\n}\n\n.documentacion-container > .card h5 i {\n    margin-right: 8px;\n}\n\n.documentacion-container > .card button i {\n    margin-right: 8px;\n}\n\n@media (max-width: 500px) {\n    .documentacion-container {\n        width: 100%;\n        margin: 0 0;\n        padding-bottom: 250px !important;\n        height: 100vh;\n        overflow-y: scroll;\n    }\n\n    .documentacion-container > .card {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
